<template>
  <AppHeader />
  <Suspense>
    <template #default>
      <AppHomePage />
    </template>
    <template #fallback>
      <AppLoading />
    </template>
  </Suspense>
  <AppFooter />
</template>

<script>
// @ is an alias to /src
import AppLoading from "@/components/Include/AppLoading.vue";
import AppHeader from "@/components/Include/AppHeader.vue";
import AppFooter from "@/components/Include/AppFooter.vue";
import AppHomePage from "@/components/Pages/AppHomePage.vue";

export default {
  name: "HomeView",
  components: {
    AppLoading,
    AppHeader,
    AppFooter,
    AppHomePage,

  },
};
</script>
